export const Colors = {
  white: '#FFFFFF',
  black: '#000000',
  backgroundGrey: '#E2E2E2',
  successGreen: '#16C36C',
}
